import { makeVar } from '@apollo/client';

export const exportModalOpenVar = makeVar(false);
